import React, { FC } from "react";
import { ReactComponent as TickIocn } from "assets/images/common/svgs/tick-circle.svg";
import { ReactComponent as CardBank } from "assets/images/common/svgs/card-bank.svg";

interface Props {
  user: any;
}

const Subscription: FC<Props> = ({ user }) => {

  return (
    <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
      <div className="flex flex-wrap justify-between gap-4 items-center">
        <p className="text-sm font-medium text-uiDarkText">Current Plan</p>

        {/* <button className="px-4 py-2 text-xs bg-goldenOrangeBg text-white  rounded-lg font-semibold">
          Cancel Subscription
        </button> */}
      </div>

      <div className="flex justify-between  gap-6 flex-wrap mt-5 ">
        <div>
          <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[10px] p-3 flex justify-between gap-4 ">
            <div className="flex flex-col gap-1">
              <p className="text-2xl font-semibold text-darkTealBlue">
                {user?.user?.subscription?.product?.name}
              </p>
              <p className="text-xl text-darkTealBlue font-medium whitespace-nowrap">
                ${user?.user?.subscription?.product?.price}<span className="text-sm ml-1 font-normal">/ {user?.user?.subscription?.product?.interval}</span>
              </p>
              <p className="text-sm font-bold text-darkTealBlue">
                {user?.user?.subscription?.product?.description}
              </p>
              <p className="bg-mintLightBg text-forestGreenText font-semibold px-2 py-1 text-xs w-fit rounded-full">
                Active
              </p>
            </div>
            <div className="mt-3">
              <TickIocn />
            </div>
          </div>

          <ul className="list-inside list-disc  my-2">
            {(
              (user?.user?.subscription?.product?.name === "Basic Membership" && [
                "Badge (not customizable) - pick one",
                "Host limited to 2 sessions per month",

              ]) ||
              (user?.user?.subscription?.product?.name === "Premium Membership" && [
                "Gold level badge with customized centre (can upload logo or pic)",
                "Unlimited sessions per month",
                "May post workshop with 10% learn local fee",
              ]) ||

              (user?.user?.subscription?.product?.name === "Next level membership" && [
                "Silver level badge with customized centre (can upload logo or pic)",
                "Unlimited sessions per month",
                "May post workshop but learn local will collect 10% fee of what the host charges",
              ]) ||
              []
            ).map((feature, idx) => (
              <li key={idx} className="text-sm font-bold text-uiDarkText">

                {feature}
              </li>
            ))}
          </ul>
        </div>

        {/* <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-uiDarkText">
            Billing Information
          </span>
          <span className="text-sm font-bold text-primaryText flex flex-col gap-0">
            {`${user?.user?.firstName} ${user?.user?.lastName}`}
            <p className="font-normal">{user?.user?.email}</p>
          </span>
        </div> */}

        {/* <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-uiDarkText">
            Payment Details
          </span>
          <div className="flex items-center gap-2">
            <span>
              <CardBank />
            </span>
            <span className="text-sm font-bold text-primaryText">
              {`********${user?.user?.subscription?.product?.stripePriceId?.slice(-4)}`}

            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Subscription;
